import * as React from "react";
import { useState, useEffect, useRef } from "react";
// import Popover from '@mui/material/Popover';
import { Popover } from "antd";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import SaveIcon from "@mui/icons-material/Save";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import Divider from "@mui/material/Divider";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useContext } from "react";
import MainContext from "../../../context/mainContext";
import {
  saveWordApi,
  deleteWordsByWordApi,
} from "../../../services/userSaveWordApi";
import {
  customToastify,
  checkErrorMessage,
} from "../../pages/utils/utilsFunctions";
import SubtitleOneTranslations from "./SubtitleOneTranslations";
import { translateApi } from "../../../services/Translate/TranslateApi";
import {
  getMeiningsDexie,
  setMeiningsDexie,
  updateMeiningsDexie,
} from "./usedexi";
import AccessDeny from "../AccessDeny";
import EndTrialAlert from "./EndTrialAlert";
import Bamooz from "../../../assets/dictIcons/Bamooz.png";
import Fastdic from "../../../assets/dictIcons/Fastdic.png";
import abadis from "../../../assets/dictIcons/abadis.svg";
import bing from "../../../assets/dictIcons/bing.png";
import cambridge from "../../../assets/dictIcons/cambridge.png";
import collins from "../../../assets/dictIcons/collins.png";
import deepl from "../../../assets/dictIcons/deepl.svg";
import glosbe from "../../../assets/dictIcons/glosbe.png";
import google from "../../../assets/dictIcons/google.png";

export default function SubtitleOnePopover(props) {
  const {
    subWord,
    handlePlayingStatus,
    handleOpenSaveWordsDialog,
    handleOpenSaveAsWordsDialog,
    handleTranslateWord,
    handleDict,
    handleEnData,
    containerRef,
    typeWord,
    handleFullScreen,
    handleOpenModalAlert,
  } = props;
  const {
    videoInfo,
    subtitleOneContenet,
    subtitleTwoContenet,
    userWords,
    handleUserWords,
    subWordLearningStyles,
    userTypes,
    userWordsDifficultyLevel,
    cferWordsLevel,
    subWordCEFRStyles,
  } = useContext(MainContext);
  const [popOverContent, setPopOverContent] = useState("");
  const [translateWord, setTranslateWord] = useState("");
  const [dict, setDict] = useState(false);
  const [enDataDict, setEnDataDict] = useState(false);

  const handleCustomSaveWords = () => {
    if (
      userTypes.includes("userPremium") ||
      userTypes.includes("admin") ||
      userTypes.includes("freetrial_all")
    ) {
      handleTranslateWord(translateWord);
      handleDict(dict);
      handleEnData(enDataDict);
      handleOpenSaveAsWordsDialog(false);
    } else {
      setPopOverContent(<EndTrialAlert handleFullScreen={handleFullScreen} />);
    }
  };

  const handleCustomSaveAsWords = (dictName) => {
    if (
      userTypes.includes("userPremium") ||
      userTypes.includes("admin") ||
      userTypes.includes("freetrial_all")
    ) {
      handleTranslateWord(translateWord);
      handleDict(dict);
      handleEnData(enDataDict);
      handleOpenSaveAsWordsDialog(false);
      if (dictName) {
        handleDictOpen(dictName);
      }
    } else {
      handleOpenModalAlert();
    }
  };

  const saveAllMeinings = async () => {
    if (
      userTypes.includes("userPremium") ||
      userTypes.includes("admin") ||
      userTypes.includes("freetrial_all")
    ) {
      try {
        const data = {
          fromLang: videoInfo["subtitleOneLanguage"],
          toLang: videoInfo["subtitleTwoLanguage"],
          word: translateWord,
          meanings: dict[0]["translations"].slice(0, 3),
          subtitle: subtitleOneContenet,
          translateOfSubtitle: subtitleTwoContenet,
          type: typeWord,
          // subtitleStartTime:"test",
          // subtitleEndTime:"test",
          movieName: videoInfo["filmName"],
          season: videoInfo["season"],
          episode: videoInfo["episode"],
          // groups:["tessdasdt","123"]
        };
        let res = await saveWordApi(data);
        if (res["data"] && res["data"]["success"]) {
          customToastify("success", "با موفقیت ذخیره شد", 200, "top-center");
          let newUserWords = { ...userWords };
          newUserWords["userSavedWords"] = [
            ...userWords["userSavedWords"],
            translateWord.toLowerCase(),
          ];
          handleUserWords(newUserWords);
        }
      } catch (error) {
        const errData = checkErrorMessage(error);
        customToastify(
          "error",
          `مشکل در ذخیره ${translateWord} :${
            errData["titles"] || errData["message"]
          }`,
          2000,
          "top-center"
        );
        console.error(error);
      }
    } else {
      setPopOverContent(<EndTrialAlert handleFullScreen={handleFullScreen} />);
    }
  };

  const deleteWord = async () => {
    try {
      const data = {
        fromLang: videoInfo["subtitleOneLanguage"],
        toLang: videoInfo["subtitleTwoLanguage"],
        word: translateWord,
      };
      let res = await deleteWordsByWordApi(data);
      if (res["data"] && res["data"]["success"]) {
        customToastify("warning", "با موفقیت حذف شد", 200, "top-center");
        let newUserWords = { ...userWords };
        let existWord = true;
        while (existWord) {
          var indexWord = newUserWords["userSavedWords"].indexOf(
            translateWord.toLowerCase()
          );
          if (indexWord !== -1) {
            newUserWords["userSavedWords"].splice(indexWord, 1);
          } else existWord = false;
        }
        handleUserWords(newUserWords);
      } else {
        if (
          res["data"] &&
          res["data"]["message"] == "این لغت برای حذف وجود ندارد"
        )
          customToastify(
            "error",
            `لغت ${translateWord} قبلا حذف شده است اما ممکن است لغت دیگری با حروف کوچک یا بزرگ  متفاوت وجود داشته باشد`,
            3000,
            "top-center"
          );
        else
          customToastify(
            "error",
            "مشکلی در حذف لغت وجود دارد",
            500,
            "top-center"
          );
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      customToastify(
        "error",
        `مشکل در حذف ${translateWord} :${
          errData["titles"] || errData["message"]
        }`,
        2000,
        "top-center"
      );
      console.error(error);
    }
  };

  const getMeinings = async (word) => {
    try {
      const fromLang = videoInfo["subtitleOneLanguage"];
      const toLang = videoInfo["subtitleTwoLanguage"];
      if (userTypes.length == 0) {
        setPopOverContent(
          <AccessDeny handlePlayingStatus={handlePlayingStatus} />
        );
      } else if (
        userTypes.includes("userPremium") ||
        userTypes.includes("admin") ||
        userTypes.includes("freetrial_dict") ||
        userTypes.includes("freetrial_all")
      ) {
        setDict(false);
        setEnDataDict(false);
        setPopOverContent(
          <SubtitleOneTranslations dict={dict} loadingSub={true} />
        );
        let arrayOfDict = [];
        let arrayOfDictEnData = [];
        let dexieResult = await getMeiningsDexie({ fromLang, toLang, word });
        // در نسخه اولیه برنامه فقط سه ترجمه با اسم meinings ذخیره میشد و بعدا dict اضافه گردید
        if (
          dexieResult.length > 0 &&
          dexieResult[0]["dict"] &&
          dexieResult[0]["dict"].length > 0
        ) {
          arrayOfDict = dexieResult[0]["dict"];
          arrayOfDictEnData = dexieResult[0]["enData"] || [];
        } else if (
          dexieResult.length > 0 &&
          dexieResult[0]["meinings"] &&
          dexieResult[0]["meinings"].length > 0
        ) {
          let response = await translateApi({ word, fromLang, toLang });
          if (response.status == 200) {
            arrayOfDict = response["data"]["data"]["dict"];
            let saveData = {
              fromLang,
              toLang,
              word,
              dict: arrayOfDict,
            };
            if (
              response["data"]["enData"] &&
              response["data"]["enData"].length > 0
            ) {
              saveData["enData"] = response["data"]["enData"];
              arrayOfDictEnData = response["data"]["enData"];
            }
            await updateMeiningsDexie(saveData);
          }
        } else {
          let response = await translateApi({ word, fromLang, toLang });
          if (response.status == 200) {
            arrayOfDict = response["data"]["data"]["dict"];
            let saveData = {
              fromLang,
              toLang,
              word,
              dict: arrayOfDict,
            };
            if (
              response["data"]["enData"] &&
              response["data"]["enData"].length > 0
            ) {
              saveData["enData"] = response["data"]["enData"];
              arrayOfDictEnData = response["data"]["enData"];
            }
            await setMeiningsDexie(saveData);
          }
        }
        if (arrayOfDict.length > 0) {
          setDict(arrayOfDict);
          setTranslateWord(word);
          setPopOverContent(
            <SubtitleOneTranslations loadingSub={true} dict={arrayOfDict} />
          );
          if (arrayOfDictEnData.length > 0) {
            setEnDataDict(arrayOfDictEnData);
          }
        } else {
          setDict(false);
          setEnDataDict(false);
        }
      } else {
        setPopOverContent(
          <AccessDeny
            handleFullScreen={handleFullScreen}
            onlyUserPremium={true}
            trailDict={`dict_${fromLang}_${toLang}`}
          />
        );
      }
    } catch (error) {
      console.error("SubtitleOnePopover", error);
      setPopOverContent("مشکل در بارگزاری اطلاعات");
      if (error["response"]["data"]["data"]["params"]) {
        if (error["response"]["data"]) {
          if (error["response"]["data"]["data"]) {
            if (
              error["response"]["data"]["data"]["params"] &&
              error["response"]["data"]["data"]["params"].length > 0
            ) {
              error["response"]["data"]["data"]["params"].forEach((el) => {
                if (el["name"] == "endTrials")
                  setPopOverContent(<EndTrialAlert handleFullScreen={handleFullScreen}/>);
              });
            }
          }
        }
      }
    }
  };

  const handleDictOpen = (dict) => {
    if (dict == "Bamooz") {
      window.open(
        `https://dic.b-amooz.com/${videoInfo["subtitleOneLanguage"]}/dictionary/w?word=${subWord}`,
        "mozillaWindow",
        "popup"
      );
    } else if (dict == "Fastdic") {
      window.open(
        `https://fastdic.com/word/${subWord}`,
        "mozillaWindow",
        "popup"
      );
    } else if (dict == "abadis") {
      window.open(
        `https://abadis.ir/entofa/${subWord}`,
        "mozillaWindow",
        "popup"
      );
    } else if (dict == "bing") {
      window.open(
        `https://www.bing.com/translator/?from=${videoInfo["subtitleOneLanguage"]}&to=${videoInfo["subtitleTwoLanguage"]}&text=${subWord}`,
        "mozillaWindow",
        "popup"
      );
    } else if (dict == "cambridge") {
      window.open(
        `https://dictionary.cambridge.org/dictionary/english/${subWord}`,
        "mozillaWindow",
        "popup"
      );
    } else if (dict == "collins") {
      let dictUri = "";
      if (videoInfo["subtitleOneLanguage"] == "en")
        dictUri = `https://www.collinsdictionary.com/dictionary/english/${subWord}`;
      else if (videoInfo["subtitleOneLanguage"] == "de")
        dictUri = `https://www.collinsdictionary.com/dictionary/german-english/${subWord}`;
      else if (videoInfo["subtitleOneLanguage"] == "fr")
        dictUri = `https://www.collinsdictionary.com/dictionary/french-english/${subWord}`;
      else if (videoInfo["subtitleOneLanguage"] == "it")
        dictUri = `https://www.collinsdictionary.com/dictionary/italian-english/${subWord}`;
      window.open(dictUri, "mozillaWindow", "popup");
    } else if (dict == "glosbe") {
      window.open(
        `https://glosbe.com/${videoInfo["subtitleOneLanguage"]}/${videoInfo["subtitleTwoLanguage"]}/${subWord}`,
        "mozillaWindow",
        "popup"
      );
    } else if (dict == "google") {
      window.open(
        `https://translate.google.com/?sl=${videoInfo["subtitleOneLanguage"]}&tl=${videoInfo["subtitleTwoLanguage"]}&text=${subWord}&op=translate`,
        "mozillaWindow",
        "popup"
      );
    }
  };

  const tooltip = () => (
    <React.Fragment>
      {videoInfo["subtitleOneLanguage"] == "en" ? (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            // backgroundColor: "#b4b4f1",
          }}
        >
          <IconButton
            onClick={() => {
              handleCustomSaveAsWords("Bamooz");
            }}
            sx={{ border: "1px solid", padding: "2px", margin: "1px" }}
            aria-label="Bamooz"
            color="primary"
          >
            <img src={Bamooz} height={10} width={10} />
          </IconButton>
          <IconButton
            onClick={() => {
              handleCustomSaveAsWords("Fastdic");
            }}
            sx={{ border: "1px solid", padding: "2px", margin: "1px" }}
            aria-label="Fastdic"
            color="primary"
          >
            <img src={Fastdic} height={10} width={10} />
          </IconButton>
          <IconButton
            onClick={() => {
              handleCustomSaveAsWords("abadis");
            }}
            sx={{ border: "1px solid", padding: "2px", margin: "1px" }}
            aria-label="abadis"
            color="primary"
          >
            <img src={abadis} height={10} width={10} />
          </IconButton>
          <IconButton
            onClick={() => {
              handleCustomSaveAsWords("bing");
            }}
            sx={{ border: "1px solid", padding: "2px", margin: "1px" }}
            aria-label="bing"
            color="primary"
          >
            <img src={bing} height={10} width={10} />
          </IconButton>
          <IconButton
            onClick={() => {
              handleCustomSaveAsWords("cambridge");
            }}
            sx={{ border: "1px solid", padding: "2px", margin: "1px" }}
            aria-label="cambridge"
            color="primary"
          >
            <img src={cambridge} height={10} width={10} />
          </IconButton>
          <IconButton
            onClick={() => {
              handleCustomSaveAsWords("collins");
            }}
            sx={{ border: "1px solid", padding: "2px", margin: "1px" }}
            aria-label="collins"
            color="primary"
          >
            <img src={collins} height={10} width={10} />
          </IconButton>
          <IconButton
            onClick={() => {
              handleCustomSaveAsWords("glosbe");
            }}
            sx={{ border: "1px solid", padding: "2px", margin: "1px" }}
            aria-label="glosbe"
            color="primary"
          >
            <img src={glosbe} height={10} width={10} />
          </IconButton>
          <IconButton
            onClick={() => {
              handleCustomSaveAsWords("google");
            }}
            sx={{ border: "1px solid", padding: "2px", margin: "1px" }}
            aria-label="google"
            color="primary"
          >
            <img src={google} height={10} width={10} />
          </IconButton>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            backgroundColor: "#b4b4f1",
          }}
        >
          {videoInfo["subtitleOneLanguage"] == "de" ||
          videoInfo["subtitleOneLanguage"] == "tr" ||
          videoInfo["subtitleOneLanguage"] == "fr" ? (
            <IconButton
              onClick={() => {
                handleCustomSaveAsWords("Bamooz");
              }}
              sx={{ border: "1px solid", padding: "2px", margin: "1px" }}
              aria-label="Bamooz"
              color="primary"
            >
              <img src={Bamooz} height={10} width={10} />
            </IconButton>
          ) : null}
          {videoInfo["subtitleOneLanguage"] !== "tr" ? (
            <IconButton
              onClick={() => {
                handleCustomSaveAsWords("collins");
              }}
              sx={{ border: "1px solid", padding: "2px", margin: "1px" }}
              aria-label="collins"
              color="primary"
            >
              <img src={collins} height={10} width={10} />
            </IconButton>
          ) : null}

          <IconButton
            onClick={() => {
              handleCustomSaveAsWords("deepl");
            }}
            sx={{ border: "1px solid", padding: "2px", margin: "1px" }}
            aria-label="deepl"
            color="primary"
          >
            <img src={deepl} height={10} width={10} />
          </IconButton>

          <IconButton
            onClick={() => {
              handleCustomSaveAsWords("glosbe");
            }}
            sx={{ border: "1px solid", padding: "2px", margin: "1px" }}
            aria-label="glosbe"
            color="primary"
          >
            <img src={glosbe} height={10} width={10} />
          </IconButton>

          <IconButton
            onClick={() => {
              handleCustomSaveAsWords("google");
            }}
            sx={{ border: "1px solid", padding: "2px", margin: "1px" }}
            aria-label="google"
            color="primary"
          >
            <img src={google} height={10} width={10} />
          </IconButton>
          <IconButton
            onClick={() => {
              handleCustomSaveAsWords("bing");
            }}
            sx={{ border: "1px solid", padding: "2px", margin: "1px" }}
            aria-label="bing"
            color="primary"
          >
            <img src={bing} height={10} width={10} />
          </IconButton>
        </Box>
      )}
      <Box color="inherit">{popOverContent}</Box>
      <Divider sx={{ bgcolor: "red" }} />
      {userWords["userSavedWords"].includes(subWord.toLowerCase()) ? (
        <IconButton
          disabled={!dict}
          aria-label="delete"
          onClick={() => {
            deleteWord();
          }}
        >
          <DeleteForeverIcon fontSize="small" color="secondary" />
        </IconButton>
      ) : (
        ""
      )}
      <IconButton
        disableRipple={true}
        disabled={!dict}
        onClick={() => {
          saveAllMeinings();
        }}
      >
        <SaveIcon fontSize="small" color="success" />
      </IconButton>
      <IconButton
        aria-label="delete"
        disabled={!dict}
        onClick={handleCustomSaveWords}
      >
        <SaveAsIcon fontSize="small" color="secondary" />
      </IconButton>
    </React.Fragment>
  );

  const getWordLevel = (word) => {
    let level = false;
    let getIndex = userWordsDifficultyLevel["words"].indexOf(word);
    if (getIndex >= 0) {
      level = userWordsDifficultyLevel["levels"][getIndex];
    }
    return level;
  };

  const getWordCEFRLevel = (word) => {
    let level = false;
    let getIndex = cferWordsLevel["words"].indexOf(word);
    if (getIndex >= 0) {
      level = cferWordsLevel["levels"][getIndex];
    }
    return level;
  };

  const getColor = (word, checkType) => {
    let newStyle = {};
    if (checkType == "userWord") {
      const level = getWordLevel(word);
      if (level && subWordLearningStyles[`co_on_${level}`]) {
        newStyle.color = subWordLearningStyles[`co_${level}`];
      }
    }
    if (checkType == "cefrWord") {
      const level = getWordCEFRLevel(word);
      if (level && subWordCEFRStyles[`co_on_${level}`]) {
        newStyle.color = subWordCEFRStyles[`co_${level}`];
      }
    }
    if (checkType == "userReadyWord") {
      const level = getWordLevel(word);
      if (level && subWordLearningStyles[`co_on_${level}`]) {
        newStyle.color = subWordLearningStyles[`co_${level}`];
      }
    }
    return newStyle;
  };

  const getBkColor = (word, checkType) => {
    let newStyle = {};
    if (checkType == "userWord") {
      const level = getWordLevel(word);
      if (level && subWordLearningStyles[`bk_on_${level}`]) {
        newStyle.background = subWordLearningStyles[`bk_${level}`];
      }
    }
    if (checkType == "cefrWord") {
      const level = getWordCEFRLevel(word);
      if (level && subWordCEFRStyles[`bk_on_${level}`]) {
        newStyle.background = subWordCEFRStyles[`bk_${level}`];
      }
    }
    if (checkType == "userReadyWord") {
      const level = getWordLevel(word);
      if (level && subWordLearningStyles[`bk_on_${level}`]) {
        newStyle.background = subWordLearningStyles[`bk_${level}`];
      }
    }
    return newStyle;
  };

  const checkWordStyle = (word) => {
    let style = {};
    if (subWordCEFRStyles["co_on"])
      style = { ...style, ...getColor(word, "cefrWord") };
    if (subWordLearningStyles["co_on"])
      style = { ...style, ...getColor(word, "userWord") };
    if (subWordLearningStyles["co_on_10"])
      style = { ...style, ...getColor(word, "userReadyWord") };
    if (subWordCEFRStyles["bk_on"])
      style = { ...style, ...getBkColor(word, "cefrWord") };
    if (subWordLearningStyles["bk_on"])
      style = { ...style, ...getBkColor(word, "userWord") };
    if (subWordLearningStyles["bk_on_10"])
      style = { ...style, ...getBkColor(word, "userReadyWord") };
    return style;
  };

  return (
    <span>
      <Popover
        getPopupContainer={() => containerRef}
        placement="top"
        content={tooltip}
        style={{ padding: "15px" }}
      >
        <span
          variant="contained"
          onMouseEnter={(e) => {
            setDict(false);
            setEnDataDict(false);
            setPopOverContent(false);
            getMeinings(e.currentTarget.innerText);
          }}
          // برای استایل دادن به هر لغت از این قسمت این کار را میکنیم
          style={checkWordStyle(subWord.toLowerCase())}
        >
          {subWord}
        </span>
      </Popover>
    </span>
  );
}
